import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import Main from './views/Main';
import Checkout from './views/Checkout';
import './App.css';
import './css/normalize.css';
import ScrollToTopOnNav from './components/ScrollToTopOnNav';

class App extends Component {
  render () {
    // console.log(process.env['REACT_APP_GRAPHQL_URL_' + process.env.REACT_APP_ENV.toUpperCase()]);
    // console.log(process.env['REACT_APP_BSL_APP_URL_' + process.env.REACT_APP_ENV.toUpperCase()]);
    return (
      <div>
        <ScrollToTopOnNav />
        <Switch>
          <Route path='/checkout' component={Checkout} />
          <Route path='/' component={Main} />
        </Switch>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js